<mat-card class="p-0 overflow-hidden text-white promotion-card">
  <img [src]="promoData.imgUrl" class="img-fluid" [alt]="imageLink.text" />
  <div class="card-img-overlay">
    <h2>{{ promoData.title | uppercase }}</h2>
    <p class="card-text" matTooltip="{{ promoData.description }}">
      {{
        promoData.description.length > 15
          ? promoData.description.substring(0, 15) + "..."
          : promoData.description
      }}
    </p>
    <p *ngIf="promoData.status === 1" class="card-text">Active</p>
    <p *ngIf="promoData.status === 2" class="card-text">Deactivated</p>
    <p class="card-text">
      <small>{{ promoData.creationDate | date: "short" }}</small>
    </p>
  </div>
  <button
    class="ms-auto option-btn"
    mat-icon-button
    aria-label="option menu"
    [matMenuTriggerFor]="menu"
  >
    <mat-icon>more_horiz</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="onEditPromo()">
      <mat-icon class="material-icons-outlined">edit</mat-icon>
      <span>Edit</span>
    </button>
    <button
      *ngIf="promoData.status === 1"
      mat-menu-item
      (click)="onDeactivate()"
    >
      <mat-icon class="material-icons-outlined">block</mat-icon>
      <span>De-activate</span>
    </button>
  </mat-menu>
</mat-card>
